__turbopack_context__.v({
  "CardPriceTag": "RelatedProductCard-module__Qt5_tG__CardPriceTag",
  "CardReviewText": "RelatedProductCard-module__Qt5_tG__CardReviewText",
  "DiscountTag": "RelatedProductCard-module__Qt5_tG__DiscountTag",
  "ProductCard": "RelatedProductCard-module__Qt5_tG__ProductCard",
  "active": "RelatedProductCard-module__Qt5_tG__active",
  "addToCartBtn": "RelatedProductCard-module__Qt5_tG__addToCartBtn",
  "attribute": "RelatedProductCard-module__Qt5_tG__attribute",
  "attributes": "RelatedProductCard-module__Qt5_tG__attributes",
  "brandButton": "RelatedProductCard-module__Qt5_tG__brandButton",
  "button": "RelatedProductCard-module__Qt5_tG__button",
  "buttons": "RelatedProductCard-module__Qt5_tG__buttons",
  "buttonsContainer": "RelatedProductCard-module__Qt5_tG__buttonsContainer",
  "cardBody": "RelatedProductCard-module__Qt5_tG__cardBody",
  "cardButton": "RelatedProductCard-module__Qt5_tG__cardButton",
  "cardImage": "RelatedProductCard-module__Qt5_tG__cardImage",
  "cardPriceTag": "RelatedProductCard-module__Qt5_tG__cardPriceTag",
  "cardReviewText": "RelatedProductCard-module__Qt5_tG__cardReviewText",
  "cardTextContents": "RelatedProductCard-module__Qt5_tG__cardTextContents",
  "cardTitle": "RelatedProductCard-module__Qt5_tG__cardTitle",
  "cardTop": "RelatedProductCard-module__Qt5_tG__cardTop",
  "cart": "RelatedProductCard-module__Qt5_tG__cart",
  "comingSoon": "RelatedProductCard-module__Qt5_tG__comingSoon",
  "count": "RelatedProductCard-module__Qt5_tG__count",
  "discountTag": "RelatedProductCard-module__Qt5_tG__discountTag",
  "freeDeliveryTag": "RelatedProductCard-module__Qt5_tG__freeDeliveryTag",
  "full": "RelatedProductCard-module__Qt5_tG__full",
  "higherQuantity": "RelatedProductCard-module__Qt5_tG__higherQuantity",
  "icon": "RelatedProductCard-module__Qt5_tG__icon",
  "image": "RelatedProductCard-module__Qt5_tG__image",
  "lg": "RelatedProductCard-module__Qt5_tG__lg",
  "lg2": "RelatedProductCard-module__Qt5_tG__lg2",
  "loading": "RelatedProductCard-module__Qt5_tG__loading",
  "md": "RelatedProductCard-module__Qt5_tG__md",
  "message": "RelatedProductCard-module__Qt5_tG__message",
  "outOfStock": "RelatedProductCard-module__Qt5_tG__outOfStock",
  "outOfStockText": "RelatedProductCard-module__Qt5_tG__outOfStockText",
  "overlay": "RelatedProductCard-module__Qt5_tG__overlay",
  "popIn": "RelatedProductCard-module__Qt5_tG__popIn",
  "popOut": "RelatedProductCard-module__Qt5_tG__popOut",
  "preOrderText": "RelatedProductCard-module__Qt5_tG__preOrderText",
  "prePrice": "RelatedProductCard-module__Qt5_tG__prePrice",
  "price": "RelatedProductCard-module__Qt5_tG__price",
  "quantityBtn": "RelatedProductCard-module__Qt5_tG__quantityBtn",
  "rating": "RelatedProductCard-module__Qt5_tG__rating",
  "removeBtn": "RelatedProductCard-module__Qt5_tG__removeBtn",
  "removeButton": "RelatedProductCard-module__Qt5_tG__removeButton",
  "reverse": "RelatedProductCard-module__Qt5_tG__reverse",
  "sm": "RelatedProductCard-module__Qt5_tG__sm",
  "spin": "RelatedProductCard-module__Qt5_tG__spin",
  "top": "RelatedProductCard-module__Qt5_tG__top",
  "wishlist": "RelatedProductCard-module__Qt5_tG__wishlist",
  "xl": "RelatedProductCard-module__Qt5_tG__xl",
  "xs": "RelatedProductCard-module__Qt5_tG__xs",
});
